import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { AppRoot } from "@/AppRoot";
import { forceReloadOnChunkFailure } from "@/lib/utils/browserUtils";

window.addEventListener("vite:preloadError", (event) => {
  console.error("vite:preloadError");
  forceReloadOnChunkFailure();
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AppRoot />
);
